import { render, staticRenderFns } from "./messageTemplateEditor.vue?vue&type=template&id=08e40f92&scoped=true&"
import script from "./messageTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./messageTemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./messageTemplateEditor.vue?vue&type=style&index=0&id=08e40f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e40f92",
  null
  
)

export default component.exports